import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 1,
  class: "regles-panneau"
}
const _hoisted_4 = { class: "regles-panneau__entete" }
const _hoisted_5 = { class: "regles-panneau__contenu" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "regles-panneau__item-titre" }
const _hoisted_8 = { class: "regles-panneau__item-texte" }
const _hoisted_9 = {
  key: 1,
  class: "regles-panneau__vide"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isActif)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.panneauOuvert)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "regles-panneau__bouton-ouvrir",
              title: _ctx.$t('regles_gestion.ouvrir'),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ouvrir && _ctx.ouvrir(...args)))
            }, " RDG ", 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "Règles de gestion de la page", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "regles-panneau__fermer",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fermer && _ctx.fermer(...args)))
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.regles.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.regles, (regle) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: regle.cle,
                        class: "regles-panneau__item",
                        onClick: ($event: any) => (_ctx.mettreEnAvant(regle.cle))
                      }, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(regle.titre), 1),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(regle.texte), 1)
                      ], 8, _hoisted_6))
                    }), 128))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('regles_gestion.aucune')), 1))
              ])
            ]))
      ]))
    : _createCommentVNode("", true)
}